import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    container: {
        borderRadius: '5px',
        height: 'clamp(400px, 65dvh, 900px)',
        display: 'flex',
        overflowX: 'scroll',
        overscrollBehaviorX: 'contain',
        overflowY: 'hidden',
        width: '100%',
        marginTop: '20px',
    },
    content: {
        height: '100%',
        overflowY: 'scroll',
        overscrollBehaviorY: 'contain',
        boxSizing: 'border-box',
    },
    leftContent: {
        display: 'flex',
        flexDirection: 'column',
        width: '300px',
        minWidth: '150px',
        flexShrink: 1,
    },
    rightContent: {
        flex: 1,
        minWidth: '250px',
        display: 'flex',
        justifyContent: 'center',
    },
}));
